<div class="form-group">
  <label for="name" class="col-sm-2 control-label">Name</label>
  <div class="col-sm-10">
    <input type="text" class="form-control" name="name" id="name" placeholder="Expenditure Name" [(ngModel)]="expenditure.name" required>
  </div>
</div>

<div class="form-group">
  <label for="name" class="col-sm-2 control-label">Category</label>
  <div class="col-sm-10">
    <app-expenditure-category-select [model]="expenditure" [required]="true"></app-expenditure-category-select>
  </div>
</div>

<div class="form-group">
  <div class="col-sm-offset-2 col-sm-10 text-right">
    <button type="submit" class="btn btn-success">Save</button>
  </div>
</div>
